var _path, _path2, _g, _path3, _path4, _path5, _g2, _g3, _g4, _g5, _path6, _g6, _g7, _g8, _g9, _g10, _circle, _path7, _path8, _path9, _path10, _path11, _path12, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAwaitingRegistration(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 315,
    height: 133,
    viewBox: "0 0 315 133",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M199.691 84.4578L123.731 72.8972C123.207 72.8173 122.934 73.4999 123.371 73.8004C126.612 76.0265 131.504 79.3703 134.067 81.0633C137.946 83.6246 144.853 87.9381 155.752 92.653C166.651 97.3679 171.74 95.088 172.897 94.8941C174.054 94.7003 184.733 90.2944 186.545 89.7529C188.357 89.2114 192.329 88.7837 193.158 88.7637C193.821 88.7476 197.925 89.6771 199.924 90.016L199.691 84.4578Z",
    fill: "url(#paint0_linear_9594_99761)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M181.401 81.8049L176.115 80.7849L182.792 91.1243L186.13 89.7798L181.401 81.8049Z",
    fill: "#C4C4C4"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_9594_99761)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M199.046 85.2204L124.347 73.624L126.956 75.1789L198.879 86.8837L199.046 85.2204Z",
    fill: "url(#paint1_linear_9594_99761)"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M219.651 95.2083C222.936 96.177 226.59 95.89 229.833 94.1179C236.304 90.5811 238.683 82.4679 235.146 75.9966C231.609 69.5253 223.496 67.1464 217.025 70.6833C211.739 73.5723 209.183 79.5147 210.352 85.1216L199.097 84.2859L199.131 89.7623L219.651 95.2083ZM226.305 88.4372C229.361 86.7671 230.484 82.9358 228.814 79.8799C227.144 76.824 223.313 75.7007 220.257 77.3709C217.201 79.041 216.078 82.8723 217.748 85.9282C219.418 88.9841 223.249 90.1074 226.305 88.4372Z",
    fill: "#C4C4C4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M190.395 96.92L144.584 35.2363C144.267 34.8103 144.742 34.2497 145.213 34.4953C148.698 36.3146 153.944 39.0688 156.642 40.5399C160.722 42.7655 167.769 46.8456 177.042 54.264C186.315 61.6825 186.686 67.2463 187.057 68.359C187.428 69.4718 188.541 80.9704 188.912 82.825C189.283 84.6796 190.766 88.3888 191.137 89.1306C191.434 89.7241 194.178 92.9133 195.414 94.5206L190.395 96.92Z",
    fill: "url(#paint2_linear_9594_99761)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M210.353 110.261C212.473 112.625 213.763 115.749 213.763 119.175C213.763 126.55 207.785 132.528 200.41 132.528C193.036 132.528 187.057 126.55 187.057 119.175C187.057 113.151 191.046 108.059 196.527 106.395L190.395 96.9197L195.217 94.3232L210.361 110.261L210.353 110.261ZM207.087 118.804C207.087 122.286 204.264 125.109 200.781 125.109C197.299 125.109 194.476 122.286 194.476 118.804C194.476 115.321 197.299 112.498 200.781 112.498C204.264 112.498 207.087 115.321 207.087 118.804Z",
    fill: "url(#paint3_radial_9594_99761)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_9594_99761)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M194.336 95.552L193.247 96.1316L197.675 105.405C199.701 105.067 201.769 105.067 203.795 105.405L194.336 95.552Z",
    fill: "url(#paint4_linear_9594_99761)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_9594_99761)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M195.032 95.1577L193.942 95.7373L203.888 106.146L208.431 110.876L210.564 115.28L212.326 117.506C210.951 113.502 208.746 109.833 205.855 106.739L204.954 105.775L195.032 95.1577Z",
    fill: "url(#paint5_linear_9594_99761)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_9594_99761)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M194.316 122.146L193.507 119.939C193.435 119.742 193.194 119.669 193.024 119.792C192.92 119.868 192.872 119.998 192.903 120.123L193.239 121.508C193.932 124.366 196.267 126.534 199.169 127.014L200.39 127.216C200.491 127.233 200.593 127.202 200.668 127.133C200.86 126.958 200.785 126.641 200.535 126.57L198.439 125.974C196.531 125.431 194.999 124.008 194.316 122.146Z",
    fill: "url(#paint6_radial_9594_99761)"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_f_9594_99761)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M209.873 124.287L208.787 126.66C208.676 126.903 208.804 127.188 209.059 127.267C209.248 127.325 209.453 127.251 209.561 127.086L210.818 125.156C212.64 122.358 213.02 118.859 211.841 115.735L211.725 115.426L210.049 111.359C209.94 111.095 209.682 110.922 209.396 110.922C208.907 110.922 208.566 111.406 208.73 111.867L210.227 116.052C211.187 118.738 211.06 121.693 209.873 124.287Z",
    fill: "url(#paint7_radial_9594_99761)"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M220.445 95.445C223.54 96.1553 226.899 95.7703 229.896 94.1108C236.347 90.5383 238.681 82.4121 235.109 75.9604C231.536 69.5087 223.41 67.1746 216.959 70.7471C211.689 73.6653 209.166 79.6218 210.366 85.2222L199.106 84.4485L199.17 89.9247L220.45 95.4525L220.445 95.445ZM226.337 88.4496C229.384 86.7626 230.486 82.9252 228.799 79.8786C227.112 76.8319 223.274 75.7298 220.228 77.4168C217.181 79.1038 216.079 82.9412 217.766 85.9878C219.453 89.0344 223.29 90.1366 226.337 88.4496Z",
    fill: "url(#paint8_radial_9594_99761)"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_f_9594_99761)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M199.819 88.5592L199.798 87.3252L210.055 86.7068C210.741 88.6429 211.743 90.452 213.02 92.0609L199.819 88.5592Z",
    fill: "url(#paint9_linear_9594_99761)"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_f_9594_99761)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M200.041 86.8414L199.803 85.6306L210.219 86.5113C210.42 86.5284 210.594 86.6608 210.663 86.8507C210.791 87.2032 210.514 87.571 210.139 87.5449L200.041 86.8414Z",
    fill: "url(#paint10_linear_9594_99761)"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_f_9594_99761)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M219.106 88.9813L221.114 90.2031C221.293 90.3122 221.318 90.5627 221.164 90.7054C221.07 90.7924 220.933 90.8141 220.817 90.7603L219.523 90.1621C216.853 88.9273 215.179 86.2166 215.271 83.2763L215.309 82.0396C215.312 81.9378 215.362 81.843 215.444 81.7827C215.653 81.6291 215.95 81.7642 215.971 82.0227L216.15 84.1947C216.313 86.1712 217.411 87.9506 219.106 88.9813Z",
    fill: "url(#paint11_radial_9594_99761)"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter8_f_9594_99761)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M230.879 74.6794L229.018 72.85C228.827 72.6627 228.845 72.3506 229.055 72.1859C229.211 72.0639 229.429 72.06 229.589 72.1763L231.451 73.5309C234.152 75.4948 235.755 78.628 235.767 81.967L235.768 82.2973L235.653 86.6944C235.646 86.9806 235.466 87.234 235.199 87.3361C234.742 87.5104 234.251 87.1796 234.24 86.6909L234.146 82.2472C234.085 79.395 232.913 76.6794 230.879 74.6794Z",
    fill: "url(#paint12_radial_9594_99761)"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter9_f_9594_99761)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M190.766 95.9926L145.514 35.4397L148.11 37.0161L192.157 95.0653L190.766 95.9926Z",
    fill: "url(#paint13_linear_9594_99761)"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 185.944,
    cy: 85.4216,
    r: 2.09645,
    fill: "url(#paint14_linear_9594_99761)",
    stroke: "url(#paint15_linear_9594_99761)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M193.797 49.6399L183.76 33.0678C188.563 30.7319 198.984 25.6167 202.24 23.8425C206.31 21.6247 217.583 16.3221 225.417 13.1255C231.684 10.5683 234.776 9.71651 236.299 10.3419L237.171 12.2185L219.127 38.4077C218.44 38.6868 216.803 39.3486 215.751 39.7632C214.698 40.1778 200.676 46.5204 193.797 49.6399Z",
    fill: "url(#paint16_linear_9594_99761)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M78.2474 65.0448C76.1771 65.786 24.5237 84.0614 3.39955 95.0542L26.0341 115.962L27.0572 115.359C39.4687 108.043 52.9127 102.642 66.9356 99.337C73.3015 88.0148 86.3055 66.6942 85.7849 64.1631C85.5366 62.9558 80.8352 64.1182 78.2474 65.0448Z",
    fill: "url(#paint17_linear_9594_99761)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M229.449 19.7423C232.34 17.1383 235.527 12.9299 236.759 11.1512L241.159 32.0135L225.037 37.9794C222.521 36.7505 217.395 34.1839 217.019 33.7482C216.548 33.2036 217.684 31.3944 218.945 30.142C220.206 28.8896 225.834 22.9973 229.449 19.7423Z",
    fill: "url(#paint18_linear_9594_99761)",
    stroke: "url(#paint19_linear_9594_99761)",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M85.9385 64.147L89.3586 88.5321L85.8086 91.4813L70.2837 94.8467C68.5662 93.7757 65.0024 91.4719 64.487 90.8252C63.8427 90.0168 66.1874 87.8459 67.1422 86.6923C68.0971 85.5388 74.7425 78.5557 79.4361 73.9117C83.1909 70.1965 85.3356 65.8539 85.9385 64.147Z",
    fill: "url(#paint20_linear_9594_99761)",
    stroke: "url(#paint21_linear_9594_99761)",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M149.983 71.8006L136.633 58.9737C134.894 60.4217 130.395 64.1142 126.321 67.3007C121.227 71.2838 119.412 73.4528 101.367 82.9749C84.4894 91.8809 72.8614 92.6319 69.6283 92.4851C67.0418 92.3677 64.8405 91.3656 64.4921 90.7875L69.5788 110.259C70.1725 111.704 70.1903 112.773 76.9635 112.383C85.4299 111.895 104.967 104.434 116.824 98.0619C126.755 92.7249 143.151 78.4929 149.983 71.8006Z",
    fill: "url(#paint22_linear_9594_99761)",
    stroke: "url(#paint23_linear_9594_99761)",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M222.997 54.9413C222.644 54.5405 218.86 40.6702 217.012 33.7852C217.517 34.0059 218.785 34.457 219.787 34.6429C221.961 35.0461 226.088 34.7825 229.263 34.3043C232.439 33.8262 240.135 31.7855 245.43 29.9474C250.725 28.1093 260.014 23.8487 265.487 21.0527C269.865 18.8159 278.373 13.3561 282.08 10.9058L313.927 17.346C311.475 19.2667 306.093 23.4617 304.184 24.8761C301.798 26.644 291.807 33.2515 286.192 36.4023C280.577 39.5531 271.946 43.5545 265.247 46.3898C258.547 49.225 244.508 52.7951 240.372 53.9335C236.235 55.0718 227.696 56.7275 225.596 56.338C223.496 55.9485 223.437 55.4422 222.997 54.9413Z",
    fill: "url(#paint24_linear_9594_99761)",
    stroke: "url(#paint25_linear_9594_99761)",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_9594_99761",
    x: 122.347,
    y: 71.624,
    width: 78.6991,
    height: 17.2598,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_9594_99761"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_9594_99761",
    x: 189.247,
    y: 91.552,
    width: 18.5481,
    height: 17.8525,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_9594_99761"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_9594_99761",
    x: 192.942,
    y: 94.1577,
    width: 20.3838,
    height: 24.3479,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "effect1_foregroundBlur_9594_99761"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_9594_99761",
    x: 191.894,
    y: 118.732,
    width: 9.88229,
    height: 9.48901,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "effect1_foregroundBlur_9594_99761"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_f_9594_99761",
    x: 207.688,
    y: 109.922,
    width: 5.82814,
    height: 18.3647,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "effect1_foregroundBlur_9594_99761"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_f_9594_99761",
    x: 195.798,
    y: 82.7068,
    width: 21.2221,
    height: 13.3542,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_9594_99761"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_f_9594_99761",
    x: 198.803,
    y: 84.6306,
    width: 12.8916,
    height: 3.91553,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "effect1_foregroundBlur_9594_99761"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_f_9594_99761",
    x: 214.267,
    y: 80.7178,
    width: 7.99843,
    height: 11.0718,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "effect1_foregroundBlur_9594_99761"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_f_9594_99761",
    x: 227.886,
    y: 71.0916,
    width: 8.88283,
    height: 17.2915,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "effect1_foregroundBlur_9594_99761"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter9_f_9594_99761",
    x: 143.514,
    y: 33.4397,
    width: 50.6434,
    height: 64.553,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_9594_99761"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9594_99761",
    x1: 157.383,
    y1: 98.589,
    x2: 162.871,
    y2: 74.8097,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ABABAB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DFE0E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1F1F1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_9594_99761",
    x1: 122.115,
    y1: 73.9682,
    x2: 192.969,
    y2: 87.8145,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.265625,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_9594_99761",
    x1: 188.17,
    y1: 47.402,
    x2: 164.616,
    y2: 68.9154,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ABABAB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78125,
    stopColor: "#DFE0E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1F1F1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_9594_99761",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(200.41 119.36) rotate(90) scale(13.1676 13.6554)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008C64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.458333,
    stopColor: "#49B795"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.671875,
    stopColor: "#4DE2B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.828125,
    stopColor: "#45D9AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.953125,
    stopColor: "#37C99C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.994792,
    stopColor: "#21B386"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_9594_99761",
    x1: 200.874,
    y1: 102.715,
    x2: 196.191,
    y2: 104.755,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#93FCDA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#93FCDA",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_9594_99761",
    x1: 202.647,
    y1: 100.258,
    x2: 212.187,
    y2: 118.294,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6FFE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A6FFE2",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_9594_99761",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(196.469 124.692) rotate(44.2258) scale(4.85264 5.20344)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.74
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_9594_99761",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(211.583 119.715) rotate(-97.6513) scale(13.2227 14.1786)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.72
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_9594_99761",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(223.589 82.3391) rotate(-28.9747) scale(13.1677 13.6554)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008C64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.458333,
    stopColor: "#49B795"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.671875,
    stopColor: "#4DE2B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.828125,
    stopColor: "#45D9AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.953125,
    stopColor: "#37C99C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.994792,
    stopColor: "#21B386"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_9594_99761",
    x1: 209.252,
    y1: 90.8083,
    x2: 208.768,
    y2: 85.7233,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#93FCDA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#93FCDA",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_9594_99761",
    x1: 208.805,
    y1: 89.5253,
    x2: 228.814,
    y2: 85.532,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6FFE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A6FFE2",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial_9594_99761",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(217.025 86.3754) rotate(-123.046) scale(4.85264 5.20344)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.74
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_9594_99761",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(234.106 78.3411) rotate(76.7588) scale(13.2227 14.1786)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.72
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_9594_99761",
    x1: 144.772,
    y1: 33.3069,
    x2: 190.21,
    y2: 89.4088,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.265625,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_9594_99761",
    x1: 184.461,
    y1: 86.9053,
    x2: 188.541,
    y2: 84.1234,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77292,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_9594_99761",
    x1: 183.348,
    y1: 87.0908,
    x2: 187.706,
    y2: 83.7525,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F8F8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_9594_99761",
    x1: 181.122,
    y1: 39.6598,
    x2: 251.908,
    y2: 9.48387,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#10CF99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#05A678"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_9594_99761",
    x1: 90.6819,
    y1: 61.2139,
    x2: 0.977447,
    y2: 108.633,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#079E73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#10CF99"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_9594_99761",
    x1: 233.148,
    y1: 10.4816,
    x2: 227.948,
    y2: 38.5192,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6BD8B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#008F67"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_9594_99761",
    x1: 216.342,
    y1: 24.5003,
    x2: 236.388,
    y2: 31.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_9594_99761",
    x1: 63.8864,
    y1: 105.185,
    x2: 107.063,
    y2: 70.6978,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A291"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#86FFDD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_9594_99761",
    x1: 78.2528,
    y1: 71.56,
    x2: 76.0111,
    y2: 95.6428,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_9594_99761",
    x1: 138.963,
    y1: 62.9382,
    x2: 76.025,
    y2: 106.047,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#14AA7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.208333,
    stopColor: "#69DABC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.710436,
    stopColor: "#1E9174"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.916667,
    stopColor: "#3AAB8B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.994792,
    stopColor: "#62DEB1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_9594_99761",
    x1: 114.823,
    y1: 70.2666,
    x2: 72.5764,
    y2: 95.7006,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.598166,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_9594_99761",
    x1: 225.18,
    y1: 53.4545,
    x2: 325.192,
    y2: 18.9677,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6BD8B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.206695,
    stopColor: "#05A678"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.433316,
    stopColor: "#4AC7A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0FCE97"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_9594_99761",
    x1: 236.388,
    y1: 26.7272,
    x2: 250.183,
    y2: 35.4395,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAwaitingRegistration);
export default __webpack_public_path__ + "static/media/awaiting-registration.38cecec6be3fd952e0586b2c47f38e34.svg";
export { ForwardRef as ReactComponent };